export const getSelectedData = (keyFieldData, selectedData) => {
    if (selectedData.length === 0) {
        return keyFieldData
    }
    let tempArr = [];
    for (let i = 0; i < keyFieldData.length; i++) {
        let matched = false;
        for (let j = 0; j < selectedData.length; j++) {
            if (keyFieldData[i].fieldName === selectedData[j].fieldName) {
                matched = true;
                break;
            }
        }
        if (!matched) {
            tempArr.push(keyFieldData[i]);
        }
    }
    return tempArr;
}